// import React, { createContext, useContext, useEffect } from "react";

// const SheetContext = createContext();

// export const Sheet = ({ children, open, onOpenChange }) => {
//   useEffect(() => {
//     document.body.style.overflow = open ? "hidden" : "unset";
//     return () => {
//       document.body.style.overflow = "unset";
//     };
//   }, [open]);

//   return (
//     <SheetContext.Provider value={{ open, onOpenChange }}>
//       {children}
//     </SheetContext.Provider>
//   );
// };

// export const SheetTrigger = ({ children, asChild, ...props }) => {
//   const child = React.Children.only(children);
//   return React.cloneElement(child, props);
// };

// export const SheetContent = ({ children, side = "right", className = "" }) => {
//   const { open, onOpenChange } = useContext(SheetContext);
//   if (!open) return null;

//   // --- Inline positioning and animation ---
//   const baseStyle = {
//     position: "fixed",
//     background: "#fff",
//     boxShadow: "0 0 20px rgba(0,0,0,0.2)",
//     transition: "transform 0.3s ease",
//     zIndex: 9999,
//     overflowY: "auto",
//   };

//   const positions = {
//     right: {
//       top: 0,
//       right: 0,
//       height: "100vh",
//       width: window.innerWidth <= 768 ? "100%" : "400px",
//       transform: "translateX(0)",
//     },
//     left: {
//       top: 0,
//       left: 0,
//       height: "100vh",
//       width: window.innerWidth <= 768 ? "100%" : "400px",
//       transform: "translateX(0)",
//     },
//     top: {
//       top: 0,
//       left: 0,
//       width: "100%",
//       height: "400px",
//       transform: "translateY(0)",
//     },
//     bottom: {
//       bottom: 0,
//       left: 0,
//       width: "100%",
//       height: "400px",
//       transform: "translateY(0)",
//     },
//   };

//   return (
//     <div>
//       {/* Overlay */}
//       <div
//         style={{
//           position: "fixed",
//           inset: 0,
//           background: "rgba(0,0,0,0.5)",
//           zIndex: 9998,
//         }}
//         onClick={() => onOpenChange(false)}
//       />

//       {/* Panel */}
//       <div style={{ ...baseStyle, ...positions[side] }} className={className}>
//         <button
//           onClick={() => onOpenChange(false)}
//           style={{
//             position: "absolute",
//             right: "1rem",
//             top: "1rem",
//             background: "none",
//             border: "none",
//             fontSize: "1.5rem",
//             cursor: "pointer",
//             color: "#333",
//           }}
//         >
//           ×
//         </button>
//         {children}
//       </div>
//     </div>
//   );
// };
import React, { createContext, useContext, useEffect } from "react";

const SheetContext = createContext();

export const Sheet = ({ children, open, onOpenChange }) => {
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "unset";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [open]);

  return (
    <SheetContext.Provider value={{ open, onOpenChange }}>
      {children}
    </SheetContext.Provider>
  );
};

export const SheetTrigger = ({ children, ...props }) => {
  const child = React.Children.only(children);
  return React.cloneElement(child, props);
};

export const SheetContent = ({ children, side = "right", className = "" }) => {
  const { open, onOpenChange } = useContext(SheetContext);
  if (!open) return null;

  const baseStyle = {
    position: "fixed",
    background: "#fff",
    boxShadow: "0 0 20px rgba(0,0,0,0.2)",
    transition: "transform 0.3s ease",
    zIndex: 9999,
    overflowY: "auto",
  };

  const positions = {
    right: { top: 0, right: 0, height: "100vh", width: "400px", transform: "translateX(0)" },
    left: { top: 0, left: 0, height: "100vh", width: "400px", transform: "translateX(0)" },
    top: { top: 0, left: 0, width: "100%", height: "400px", transform: "translateY(0)" },
    bottom: { bottom: 0, left: 0, width: "100%", height: "400px", transform: "translateY(0)" },
  };

  return (
    <div>
      <div
        style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 9998 }}
        onClick={() => onOpenChange(false)}
      />
      <div style={{ ...baseStyle, ...positions[side] }} className={className}>
        <button
          onClick={() => onOpenChange(false)}
          style={{
            position: "absolute",
            right: "1rem",
            top: "1rem",
            background: "none",
            border: "none",
            fontSize: "1.5rem",
            cursor: "pointer",
            color: "#333",
          }}
        >
          ×
        </button>
        {children}
      </div>
    </div>
  );
};
